export const warehouseInventoryDispatchStatus = [
  { value: "3", label: "Dispatched" },
  { value: "4", label: "Completed" },
];
